import { Resource } from '../../global/domain/resource.model';
export class ContaTev extends Resource {
	identificador: string;
	banco: number;
	conta: string;
	agencia: string;
}